import Vue from 'vue'
import VueRouter from 'vue-router'
// 获取原型对象push函数
// const originalPush = VueRouter.prototype.push

// // 获取原型对象replace函数
// const originalReplace = VueRouter.prototype.replace

// // 修改原型对象中的push函数
// VueRouter.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }

// // 修改原型对象中的replace函数
// VueRouter.prototype.replace = function replace(location) {
//     return originalReplace.call(this, location).catch(err => err)
// }

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Index',
        component: () =>
            import ('@/views/home/index.vue'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/detectionPlatform',
        name: 'DetectionPlatform',
        component: () =>
            import ('@/views/detectionPlatform/index.vue'),
        meta: {
            title: 'SharpVision智能检测平台'
        }
    },
    {
        path: '/list',
        name: 'list',
        component: () =>
            import ('@/views/list.vue'),
        meta: {
            title: 'SharpVision智能检测平台'
        }
    },
    {
        path: '/cover',
        name: 'Cover',
        component: () =>
            import ('@/views/product/cover.vue'),
        meta: {
            title: '盖检测设备'
        }
    },
    {
        path: '/bottle',
        name: 'Bottle',
        component: () =>
            import ('@/views/product/bottle.vue'),
        meta: {
            title: '瓶检测设备'
        }
    },
    {
        path: '/other',
        name: 'Other',
        component: () =>
            import ('@/views/product/other.vue'),
        meta: {
            title: '其他检测设备'
        }
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router